<template>
  <div class="container-fluid p-2 order-create">
    <h5 class="text-muted mr-auto p-2">
      <h2>{{ $t("buttons.confirmOrder") }}</h2>
    </h5>
    <validation-observer ref="v-observer" class="row">
      <div class="col-sm-6 col-12 ">
        <validation-provider v-slot="v" slim rules="required">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <label class="input-group-text" for="proposalDate">{{
                $t("basket.proposalDateTime")
              }}</label>
            </div>
            <input
              id="proposalDate"
              type="date"
              name="proposalDate"
              :value="order.proposalTime"
              class="form-control"
              :class="{
                'is-invalid': v.errors.length,
              }"
              @change="changeProposalTime"
              @keydown.prevent
              @paste.prevent
              @cut.prevent
            />
          </div>
        </validation-provider>
      </div>
      <div class="col-sm-12 col-12">
        <div class="row">
          <validation-provider v-slot="v" slim rules="required">
            <div class="col-sm-6 col-12 input-group mb-3">
              <div class="input-group-prepend">
                <label class="input-group-text" for="paymentMethodGroup">{{
                  $t("basket.paymentMethod")
                }}</label>
              </div>
              <select
                id="paymentMethodGroup"
                name="paymentMethod"
                class="form-control"
                disabled="true"
                :class="{
                  'is-invalid': v.errors.length,
                }"
                :value="customerPayment"
                @change="changePaymentState"
              >
                <option
                  v-for="p in paymentList"
                  :key="p.docEntry"
                  :value="p.docEntry"
                >
                  {{ $t("paymentMethod." + p.docEntry) }}
                </option>
              </select>
            </div>
          </validation-provider>
          <div class="col-sm-6 col-12 input-group mb-3">
            <div class="input-group-prepend">
              <label class="input-group-text" for="shippingMethodGroup">{{
                $t("basket.shippingMethod")
              }}</label>
            </div>
            <validation-provider v-slot="v" rules="required" slim>
              <select
                id="shippingMethodGroup"
                :value="order.shippingValue"
                class="form-control"
                :class="{
                  'is-invalid': v.errors.length,
                }"
                @change="changeShippingState"
              >
                <option
                  v-for="s in shippingOption"
                  :key="s.value"
                  :value="s.value"
                >
                  {{ $t("shippingMethod." + s.value) }}
                </option>
              </select>
            </validation-provider>
            <br />
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-12">
        <div class="row">
          <div class="col-sm-6 col-12 input-group mb-3">
            <div class="input-group-prepend">
              <label class="input-group-text" for="commentsGroup">{{
                $t("basket.comments")
              }}</label>
            </div>
            <textarea
              id="commentsGroup"
              rows="10"
              cols="100"
              class="w-auto"
              :maxlength="254"
              @change="changeCommentState"
            />
          </div>
          <div class="col-sm-6 input-group mb-3 total-order-summary">
            <div class="form-group col-md-12">
              <label for="net">{{ $t("basket.netAmount") }}</label>
              <input
                id="net"
                disabled="disabled"
                type="text"
                class="form-control total-order-summary"
                :value="currencyDisplay(totalPrice, false)"
                placeholder="Kwota netto"
              />
            </div>
            <div class="form-group col-md-12">
              <label for="vat"> {{ $t("basket.tax") }}</label>
              <input
                id="vat"
                disabled="disabled"
                type="text"
                class="form-control total-order-summary"
                :value="
                  checkFreeTax
                    ? currencyDisplay(totalPrice * 1.23 - totalPrice, false)
                    : 0
                "
                placeholder="Podatek"
              />
            </div>
            <div class="form-group col-md-12">
              <label for="gross">{{ $t("basket.grossAmount") }}</label>
              <input
                id="gross"
                disabled="disabled"
                type="text"
                class="form-control total-order-summary"
                :value="
                  checkFreeTax
                    ? currencyDisplay(totalPrice * 1.23, false)
                    : currencyDisplay(totalPrice, false)
                "
                placeholder="Podatek"
              />
            </div>
          </div>
        </div>
      </div>
      <div v-show="this.freeShippingValue > 0" class="col-sm-12">
        <h6 style="">
          {{ $t("orders.freeShipping") }}
          {{ currencyDisplay(this.freeShippingValue, false) }}
        </h6>
        <span style="color:red;font-size:x-small">{{ $t("orders.info") }}</span>
      </div>

      <div class="col-sm-12">
        <div class="col">
          <div class="text-center">
            <router-link to="/cart" class="btn btn-secondary m-1">
              {{ $t("buttons.back") }}
            </router-link>
            <button class="btn btn-theme-add m-1" @click="submitOrder">
              {{ $t("buttons.createOrder") }}
            </button>
          </div>
        </div>
      </div>
    </validation-observer>
  </div>
</template>
<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapActions, mapGetters, mapState, mapMutations } from "vuex";
import Countries from "../enums/CountriesEuropeanUnion";
import store from "../store";
import { currencyMixin } from "../mixins";

export default {
  name: "Checkout",
  components: { ValidationObserver, ValidationProvider },
  mixins: [currencyMixin],
  data() {
    return {
      shippingOption: [
        { value: "10", text: this.$t("basket.domesticTransport") },
        { value: "9", text: this.$t("basket.collectInStore") },
      ],
      paymentList: store.state.auth.paymentList,
      freeShippingValue: 0,
      customerPayment: "1",
    };
  },
  computed: {
    ...mapState("currency", ["currency", "ratio"]),
    ...mapState("cart", ["order"]),
    ...mapGetters("cart", ["totalPrice", "transport", "currentCustomer"]),
    ...mapGetters("auth", ["paymentCustomer"]),
    ...mapActions("auth", ["getPayment"]),
    checkFreeTax() {
      let vat = this.$store.state.customers.customer.vat;
      vat = vat.substring(0, 2);
      if (Countries.includes(vat)) return false;
      return true;
    },
  },
  methods: {
    ...mapActions({
      storeOrder: "orders/storeOrder",
      clearCart: "cart/clearCartData",
    }),
    ...mapMutations("cart", [
      "setPayment",
      "setShipping",
      "setComment",
      "setShippingValue",
      "setProposalTime",
    ]),
    async submitOrder() {
      this.$refs["v-observer"].validate().then(async (result) => {
        if (result) {
          let order = await this.storeOrder(this.order);

          this.clearCart();
          this.$router.push({
            name: "customer",
            params: {
              id: store.state.auth.user.cardCode,
            },
          });
        }
      });
    },
    changePaymentState: function(event) {
      this.setPayment(event.target.value);
    },
    changeShippingState: function(event) {
      this.setShippingValue(event.target.value);
    },
    changeProposalTime: function(event) {
      this.setProposalTime(event.target.value);
    },
    changeDirectShippingValue: function(event) {
      this.setShippingValue(event.target.value);
    },
    changeCommentState: function(event) {
      this.setComment(event.target.value);
    },
    setFreeShippingValue: function() {
      this.freeShippingValue = 2850 - this.totalPrice;
    },
  },
  mounted() {
    // let customer = JSON.parse(JSON.stringify(this.currentCustomer));
    this.setComment("");
    this.setProposalTime(null);
    // if(this.paymentList === null){
    //   this.getPayment.then(
    //           (response) => {
    //             this.paymentList =  response;
    //             this.setPayment(customer.defaultPayment);
    //             return (this.paymentList);
    //           },
    //           (error) => {
    //             console.log(error);
    //           }
    //   );
    // }else{
    //   console.log("out")
    //   this.setPayment(customer.defaultPayment);
    // }

    console.log(this.paymentCustomer);
    this.setPayment(this.paymentCustomer);
    this.customerPayment = this.paymentCustomer;
    this.setShippingValue("");
    this.setFreeShippingValue();
  },
};
</script>
